/**
 * Hariom EpoxyShield ERP - Application Entry Point
 * React 18 with StrictMode for development warnings
 */
import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './index.css'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
